import { getSiteLocalization } from '@/lib/i18n/config/site-locales'
import { convertBytesToKb, convertBytesToMb, convertMbToBytes } from './number.formatter'

/**
 * Format a file size
 *
 * @param bytes – size in bytes
 * @param locale – e.g. 'fr-FR' or 'en-US' (default: site locale)
 *
 * @returns string, e.g.:
 *   formatSizeInMb(1048576)           // "1,00 Mo" in fr-FR
 *   formatSizeInMb(1048576, 'en-US')  // "1.00 MB"
 */
export function formatFileSize(bytes: number, locale = getSiteLocalization().locale): string {
  let unit = 'kilobyte'
  let size = convertBytesToKb(bytes)

  if (bytes >= convertMbToBytes(1)) {
    unit = 'megabyte'
    size = convertBytesToMb(bytes)
  }

  return new Intl.NumberFormat(locale, {
    unit,
    style: 'unit',
    unitDisplay: 'short',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(size)
}
